import React from "react";

export default function Phq2Form({ phq2, onChange }) {
  const set = (k, v) => onChange({ ...phq2, [k]: v });
  return (
    <div className="cn-card">
      <h3>PHQ-2</h3>
      <div className="row">
        <div>
          <label>1. Little interest or pleasure in doing things</label>
          <select value={phq2.q1} onChange={(e)=>set("q1", Number(e.target.value))}>
            <option value={0}>Not at all</option>
            <option value={1}>Several days</option>
            <option value={2}>More than half the days</option>
            <option value={3}>Nearly every day</option>
          </select>
        </div>
        <div>
          <label>2. Feeling down, depressed, or hopeless</label>
          <select value={phq2.q2} onChange={(e)=>set("q2", Number(e.target.value))}>
            <option value={0}>Not at all</option>
            <option value={1}>Several days</option>
            <option value={2}>More than half the days</option>
            <option value={3}>Nearly every day</option>
          </select>
        </div>
        <div>
          <label>
            <input type="checkbox" checked={!!phq2.reviewedPhq9}
              onChange={(e)=>set("reviewedPhq9", e.target.checked ? 1 : 0)} />
            {" "}PHQ-9 score reviewed
          </label>
        </div>
      </div>
    </div>
  );
}
